import { get } from 'lodash';

import store from 'APP_ROOT/store';
import { getCurrentUser } from 'APP_ROOT/selectors/session';
import { hasFeatures, FEATURES } from 'APP_ROOT/utils/features';

const ITEM_KEYWORD = '.item.';

export const getKey = (key, mainIndex, parentIndex) => {
  const state = store.getState();
  const currentUser = getCurrentUser(state);
  const { featureFlags = [] } = currentUser;
  const enableConditional = hasFeatures(
    featureFlags,
    FEATURES.enableNestedRepeaterConditional
  );

  if (enableConditional) {
    if (key.includes(ITEM_KEYWORD)) {
      const index = mainIndex === undefined ? parentIndex : mainIndex;
      return key.replace(ITEM_KEYWORD, `.${index}.`);
    }
  }
  return key;
};

const getDataInKey = (data, key, defaultValue = '', mainIndex, parentIndex) => {
  const newKey = getKey(key, mainIndex, parentIndex);
  if (newKey.includes('data.') && !newKey.includes('.0.')) {
    // in conditions when the key is like 'data.repeaterRepeater283.1.fieldSelect780'
    // the get method cannot read it directly because, sometines, inside 'data' the
    // field name is 'repeaterRepeater283.1.fieldSelect780' not really a repeater
    const parsedKey = newKey.split('data.')[1];
    return get(data, ['data', parsedKey], defaultValue);
  }

  return get(data, newKey, defaultValue);
};

export default getDataInKey;
